import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _toConsumableArray from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "/Users/yangwei/work/project/cat_help_admin/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import draggable from "vuedraggable";
import settingSlot from "./settingSlot";
import MaterialList from '@/components/material/list.vue';
import AppPageSelect from '@/components/app-page-select/Index.vue';
import iconSelect from "../pages/page-components/iconSelect.vue";
import { getPage as _getPage, getListByIds } from '@/api/mall/goodsspu';
import { tableOption2 } from '@/const/crud/mall/goodsspu';
export default {
  components: {
    draggable: draggable,
    settingSlot: settingSlot,
    MaterialList: MaterialList,
    AppPageSelect: AppPageSelect,
    iconSelect: iconSelect
  },
  data: function data() {
    return {
      dialogVisibleGoods: false,
      form2: {},
      tableData2: [],
      page2: {
        total: 0,
        // 总页数
        currentPage: 1,
        // 当前页数
        pageSize: 20,
        // 每页显示多少条
        ascs: [],
        //升序字段
        descs: [] //降序字段
      },

      paramsSearch2: {},
      tableLoading2: false,
      tableOption2: tableOption2,
      selectionGoodsSpu: [],
      formDataCopy: {
        showType: 'row',
        title: '最新上架',
        titleColor: 'red',
        titleIcon: 'cuIcon-like',
        showTitle: 'show',
        goodsNum: 1,
        pageSpacing: 0,
        goodsList: [],
        goodsIds: [] //用来动态获取商品数据
      },

      formData: {
        goodsIds: [] //用来动态获取商品数据
      }
    };
  },

  props: {
    showData: {
      type: Object,
      default: function _default() {}
    },
    config: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: _objectSpread({}, mapState({
    componentsList: function componentsList(state) {
      return state.divpage.componentsList;
    },
    clickComIndex: function clickComIndex(state) {
      return state.divpage.clickComIndex;
    }
  })),
  mounted: function mounted() {
    var that = this;
    if (that.IsEmptyObj(that.showData)) {
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
    } else {
      that.formData = that.showData;
    }
    that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
    // that.updateData({
    //   componentsList: that.componentsList
    // })
  },

  methods: _objectSpread(_objectSpread({}, mapMutations(['updateData'])), {}, {
    // 拖动的事件等等=======================================================>
    datadragStart: function datadragStart(e) {
      var that = this;
    },
    datadragUpdate: function datadragUpdate(e) {
      e.preventDefault();
    },
    datadragEnd: function datadragEnd(e) {
      // console.log(e, "拖动结束");
    },
    datadragMove: function datadragMove(e, originalEve) {
      return e.draggedContext.element.text !== 'Gold（不可拖动元素）';
    },
    // 删除项目
    delItem: function delItem(index) {
      var that = this;
      if (that.formData.goodsList.length <= 1) {
        that.$message.error("请至少保留一条项目");
        return false;
      }
      that.$confirm('是否删除该项目?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.formData.goodsIds, index);
        that.$delete(that.formData.goodsList, index);
      }).catch(function () {});
    },
    // 删除按钮
    delBtn: function delBtn(index) {
      var that = this;
      that.$confirm('是否删除该组件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        that.$delete(that.componentsList[that.clickComIndex].data.itemArray, index);
        that.updateData({
          componentsList: that.componentsList
        });
      }).catch(function () {});
    },
    cancel: function cancel() {
      this.$emit('cancel');
    },
    reset: function reset() {
      var that = this;
      that.formData = JSON.parse(JSON.stringify(that.formDataCopy));
      that.componentsList[that.clickComIndex]['data'] = this.formData;
    },
    confirm: function confirm() {
      this.$emit('confirm', this.formData);
    },
    delete: function _delete() {
      this.$emit('delete');
    },
    getPage2: function getPage2(page, params) {
      var _this = this;
      this.tableLoading2 = true;
      if (this.paramsSearch2.categoryId) {
        this.paramsSearch2.categoryFirst = this.paramsSearch2.categoryId[0];
        this.paramsSearch2.categorySecond = this.paramsSearch2.categoryId[1];
      }
      _getPage(Object.assign({
        current: page.currentPage,
        size: page.pageSize,
        descs: this.page2.descs,
        ascs: this.page2.ascs
      }, params, this.paramsSearch2)).then(function (response) {
        var tableData = response.data.data.records;
        tableData.forEach(function (item, index) {
          var categoryId = [];
          if (item.categoryFirst) {
            categoryId.push(item.categoryFirst);
          }
          if (item.categorySecond) {
            categoryId.push(item.categorySecond);
          }
          item.categoryId = categoryId;
        });
        _this.tableData2 = tableData;
        _this.page2.total = response.data.data.total;
        _this.page2.currentPage = page.currentPage;
        _this.page2.pageSize = page.pageSize;
        _this.tableLoading2 = false;
        // 加载列表级联数据
        _this.$nextTick(function () {
          _this.$refs.crud.dicInit('cascader');
        });
      }).catch(function () {
        _this.tableLoading2 = false;
      });
    },
    searchChange2: function searchChange2(params, done) {
      params = this.filterForm(params);
      this.paramsSearch2 = params;
      this.page2.currentPage = 1;
      this.getPage2(this.page2, params);
      done();
    },
    refreshChange2: function refreshChange2(val) {
      this.getPage2(val.page);
    },
    sortChange2: function sortChange2(val) {
      var prop = val.prop ? val.prop.replace(/([A-Z])/g, "_$1").toLowerCase() : '';
      if (val.order == 'ascending') {
        this.page2.descs = [];
        this.page2.ascs = prop;
      } else if (val.order == 'descending') {
        this.page2.ascs = [];
        this.page2.descs = prop;
      } else {
        this.page2.ascs = [];
        this.page2.descs = [];
      }
      this.getPage(this.page);
    },
    selectionChange2: function selectionChange2(list) {
      this.selectionGoodsSpu = list;
    },
    showGoodsList: function showGoodsList() {
      this.tableData2 = [];
      this.dialogVisibleGoods = true;
      this.getPage2(this.page2);
    },
    refreshFormData: function refreshFormData() {
      //同步数据
      var that = this;
      that.$set(that.componentsList[that.clickComIndex], 'data', this.formData);
      that.updateData({
        componentsList: that.componentsList
      });
      this.dialogVisibleGoods = false;
    },
    subGoods: function subGoods() {
      var goodsIds = this.selectionGoodsSpu.map(function (item) {
        return item.id;
      });
      var goodsList = []; // 去重
      this.formData.goodsList.map(function (item) {
        if (item && goodsIds.indexOf(item.id) === -1) {
          goodsIds.push(item.id);
          goodsList.push(item);
        }
      });
      this.formData.goodsList = [].concat(_toConsumableArray(this.selectionGoodsSpu), goodsList);
      this.formData.goodsIds = goodsIds;
      this.dialogVisibleGoods = false;
    },
    getGoodsListByIds: function getGoodsListByIds() {
      var _this2 = this;
      //根据ids获取商品
      if (this.formData.goodsIds && this.formData.goodsIds.length) getListByIds(this.formData.goodsIds).then(function (response) {
        //如果之前的商品被删除了，那么需要自动删掉处理
        var hasGoodsIds = response.data.data.map(function (item) {
          return item.id;
        });
        var goodsIds = JSON.parse(JSON.stringify(_this2.formData.goodsIds));
        goodsIds.map(function (item, index) {
          var hasIndex = hasGoodsIds.indexOf(item);
          if (hasIndex === -1) {
            _this2.formData.goodsIds.splice(index, 1);
          }
        });
        var goods = new Array(_this2.formData.goodsIds.length);
        response.data.data.map(function (item) {
          var index = _this2.formData.goodsIds.indexOf(item.id);
          goods[index] = item;
        });
        _this2.formData.goodsList = goods;
        _this2.refreshFormData();
      }).catch(function () {});else {
        this.formData.goodsList = [];
        this.refreshFormData();
      }
    }
  }),
  watch: {
    showData: {
      handler: function handler(newVal, oldVal) {
        this.formData = newVal ? newVal : this.formData;
      },
      deep: true
    },
    'formData.goodsIds': {
      handler: function handler(newVal, oldVal) {
        if (newVal && newVal.length > oldVal.length) {
          //只有在新增商品时才同步商品信息，删除或位置更换时不去请求接口
          if (newVal != oldVal) {
            this.getGoodsListByIds();
          }
        } else {
          // this.refreshFormData()
        }
      },
      deep: true
    },
    'formData.goodsList': function formDataGoodsList(val) {
      if (val) {
        this.formData.goodsIds = val.map(function (item) {
          return item.id;
        });
      } else {
        this.formData.goodsIds = [];
      }
    }
  }
};